module.exports = __webpack_public_path__ + "static/media/01_quote_tablet.9b219c6f.jpg";